import { getInstance } from "../instance";
import { MemberSubscriptionsResponse } from "./types";

/**
 * ABO read-only view of a member's subscriptions. The endpoint is versioned
 * (`/v1/...`), so we use a RELATIVE path on the shared `dsInstance` whose
 * baseURL already carries `/v1` (same pattern as `api/memberBooks/actions.ts`).
 */
const instance = getInstance();

/** A member's current subscription, live Chargebee details and history. */
export const getMemberSubscriptions = async (
  customerId: string
): Promise<MemberSubscriptionsResponse> => {
  return instance
    .get<MemberSubscriptionsResponse>(
      `/abo/customers/${customerId}/subscriptions`
    )
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
};
